export default __webpack_public_path__ + "static/media/pass.3c5e91e4.png";